import { withInstall } from '@tw-element/utils'

import Popconfirm from './src/popconfirm.vue'

export const TwPopconfirm = withInstall(Popconfirm)
export default TwPopconfirm

export * from './src/popconfirm'
